import React, { useEffect, useState } from "react";
import FeedbackService from "../../services/feeback.service";
import { Card, Col } from "react-bootstrap";
import { FeedbackTable } from "../allTables/allTable";

const Feedback = () => {
  const [totalRows, setTotalRows] = useState("");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const getAllFeedback = async () => {
    setIsLoading(true);
    try {
      const response = await FeedbackService.GetFeedback(
        pageNumber,
        dataPerPage
      );
      setTotalRows(response.data.totalCount);
      setData(response.data.data);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllFeedback();
  }, [pageNumber, dataPerPage]);

  const handlePerPageChange = async (newPerPage, newPageNumber) => {
    setIsLoading(true);
    setDataPerPage(newPerPage);
    setPageNumber(newPageNumber);
    await getAllFeedback();
    setIsLoading(false);
  };

  const handlePageChange = (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Total Feedback
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="fa fa-comment icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalRows}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </div>
      <FeedbackTable
        data={data}
        totalRows={totalRows}
        dataPerPage={dataPerPage}
        handlePerPageChange={handlePerPageChange}
        handlePageChange={handlePageChange}
        isLoading={isLoading}
        getAllFeedback={getAllFeedback}
        setDataPerPage={setDataPerPage}
      />
    </>
  );
};

export default Feedback;
